export default __webpack_public_path__ + "static/media/BeforePhoto1.a592b3c7.jpg";